<template>
  <span :class="myClass + ' price-fmt'" :style="mysty">
    <i v-if="hasUnit">￥</i>
    <span class="interge" :style="smallInterge">{{intergePrice}}</span>
    <span v-show="showPoint">.</span>
    <span class="decimal" :style="smallDecimal">{{decimalPrice}}</span>

    <span v-show="showAddPoint">.</span>
    <span v-show="showAddPoint" class="decimal" :style="smallDecimal">00</span>

    <slot name="text"></slot>
  </span>
</template>
<script>
export default {
  // twoDigit：始终保留两位小数
  props: ['price', 'mystyle', 'myclz', 'decimalSize', 'intergeSize', 'unit', 'forcePoint', 'twoDigit'],
  data() {
    return {}
  },
  computed: {
    mysty() {
      return this.$props.mystyle
    },
    myClass() {
      return this.$props.myclz || ''
    },
    hasUnit() {
      if (this.$props.unit === undefined || this.$props.unit === true) {
        return true
      } else {
        return false
      }
    },
    smallInterge() {
      let i = this.$props.intergeSize || '15px'
      return [{ 'font-size': i }]
    },
    smallDecimal() {
      let smDecimal = this.$props.decimalSize || '15px'
      return [{ 'font-size': smDecimal }]
    },
    intergePrice() {
      return this.separation(this.$props.price)[0] || 0
    },
    decimalPrice() {
      if (!this.showPoint) {
        return
      }
      const decimal = this.separation(this.$props.price)[1] || 0
      const length = decimal.length

      if (this.twoDigit) {
        if (length > 1) {
          return decimal
        } else {
          return `${decimal}0`
        }
      } else {
        return decimal || 0
      }
    },
    showPoint() {
      if (this.separation(this.$props.price).length > 1) {
        return true //不是整数,显示小数点
      } else {
        return false //是整数，不显示
      }
    },
    showAddPoint() {
      //原本不显示小数点且强制要求加入小数点
      return !this.showPoint && this.$props.forcePoint == true
    },
  },
  methods: {
    separation(value) {
      return (Math.round((+value / 100) * Math.pow(10, 2)) / Math.pow(10, 2) + '').split('.')
    },
  },
  mounted() {},
}
</script>
<style lang="less">
@orange: rgb(255, 95, 22);
.price-fmt {
  font-size: 15px;
  float: none !important;
  color: @orange;
  height: 0 !important;
  display: inline-table !important;
  span {
    float: none !important;
  }
  i {
    font-size: 11px;
    font-style: normal;
  }
}
</style>

